import { render, staticRenderFns } from "./mita_list.vue?vue&type=template&id=6041c78a&scoped=true&"
import script from "./mita_list.vue?vue&type=script&lang=js&"
export * from "./mita_list.vue?vue&type=script&lang=js&"
import style0 from "./mita_list.vue?vue&type=style&index=0&id=6041c78a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6041c78a",
  null
  
)

export default component.exports